import React, {
  useState
} from 'react';
import {
  Link,
  useLocation
} from 'react-router-dom';
import '../../styles/navigation/AdminSidebar.css';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';
import {
  faAngleDoubleLeft,
  faHome,
  faUsers,
  faShip,
  faAddressBook,
  faTags,
  faStar,
  faNewspaper,
  faFolder,
  faLock
} from '@fortawesome/free-solid-svg-icons';

const SidebarAdmin = () => {
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <button className="sidebar__toggle-button" onClick={toggleSidebar}>
        <FontAwesomeIcon icon={faAngleDoubleLeft} />
      </button>

      <div className="sidebar__content">
        <ul className="sidebar__links">
          <li>
            <Link
              to="/admin"
              className={location.pathname === '/admin' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faHome} /> Home
            </Link>
          </li>

          <li>
            <Link
              to="/admin/users"
              className={location.pathname === '/admin/users' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faUsers} /> Users
            </Link>
          </li>

          <li>
            <Link
              to="/admin/leads"
              className={location.pathname === '/admin/leads' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faAddressBook} /> Leads
            </Link>
          </li>

          <li>
            <div className="sidebar__link disabled">
              <FontAwesomeIcon icon={faNewspaper} />
              <span>Blog Posts</span>
              <FontAwesomeIcon icon={faLock} className="lock-icon" />
            </div>
          </li>

          <li>
            <div className="sidebar__link disabled">
              <FontAwesomeIcon icon={faFolder} />
              <span>Blog Categories</span>
              <FontAwesomeIcon icon={faLock} className="lock-icon" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SidebarAdmin;
